import { ConfirmSwapRequest } from "@/clients/models/ConfirmSwapRequest";
import { DataMessageResponse_dict_ } from "@/clients/models/DataMessageResponse_dict_";
import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useConfirmPlanMealSwap = () => {
  const queryClient = useQueryClient();
  const { mutate, mutateAsync, isPending, isError, error } = useMutation<
    DataMessageResponse_dict_,
    Error,
    ConfirmSwapRequest
  >({
    mutationKey: [QueryKeys.PLAN_MEAL_SWAP_CONFIRM],
    mutationFn: async (params: ConfirmSwapRequest) => {
      const user = guardGetUserFromLocalStorage();
      return PlansService.confirmMealSwapApiV1PlansMealSwapConfirmPost(user.id, {
        day: params.day,
        mealTime: params.mealTime,
        mealIndex: params.mealIndex,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.PLAN] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.MY_FOODS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BALANCE_CALORIES] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BALANCE_PROTEIN] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SHOPPING_LIST] });
    },
  });

  return {
    confirmPlanMealSwap: mutate,
    confirmPlanMealSwapAsync: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
